(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piq-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('piq-finder')) {
    const FLAVORS = {
      mint: ['mint', 'minz', 'menthol', 'ice', 'icy', 'frost', 'arctic', 'glacier', 'glaciar', 'cool', 'fresh', 'eucalyp'],
      fruit: ['berry', 'beere', 'strawberr', 'erdbeer', 'kiwi', 'lime', 'limette', 'lemon', 'zitron', 'citrus', 'cherry', 'kirsch', 'mango', 'apple', 'apfel', 'peach', 'pfirsich', 'melon', 'grape', 'traube', 'passion', 'pineapple', 'ananas', 'tropic', 'orange', 'fruit', 'frucht'],
      sweet: ['vanill', 'latte', 'mocha', 'coffee', 'kaffee', 'cola', 'bubblegum', 'kaugummi', 'candy', 'cookie', 'caramel', 'karamell', 'cream', 'sweet', 'tictac', 'dessert']
    };
    const RANGES = { low: [0, 40], mid: [41, 75], high: [76, 999] };
    const AUTO = { work: 'mid', sport: 'high', go: 'mid', snus: 'mid' };

    customElements.define(
      'piq-finder',
      class extends HTMLElement {
        connectedCallback() {
          this.answers = {};
          this.steps = Array.from(this.querySelectorAll('[data-step]'));
          this.bar = this.querySelector('[data-progress]');
          this.addEventListener('click', (e) => {
            const opt = e.target.closest('[data-answer]');
            if (opt) {
              const step = opt.closest('[data-step]').dataset.step;
              this.answers[step] = opt.dataset.answer;
              this.go(parseInt(step, 10) + 1);
            }
            if (e.target.closest('[data-restart]')) {
              this.answers = {};
              this.go(1);
            }
          });
        }

        go(n) {
          this.steps.forEach((s) => (s.hidden = parseInt(s.dataset.step, 10) !== n));
          this.bar.style.width = Math.min(100, (n - 1) * 33.4 + 8) + '%';
          if (n === 4) this.showResults();
          const card = this.querySelector('.piq-finder__card');
          if (card.getBoundingClientRect().top < 0) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        showResults() {
          const occasion = this.answers[1];
          let strength = this.answers[2];
          if (!strength || strength === 'auto') strength = AUTO[occasion] || 'mid';
          const flavor = this.answers[3];
          const [lo, hi] = RANGES[strength];
          const items = Array.from(this.querySelectorAll('.piq-finder__item'));

          const scored = items.map((el) => {
            const mg = parseFloat(el.dataset.mg) || 0;
            const hay = el.dataset.hay || '';
            const fl = el.dataset.fl || hay;
            let score = 0;
            if (mg >= lo && mg <= hi) score += 10;
            else score -= Math.min(Math.abs(mg - (mg < lo ? lo : hi)) / 20, 6);
            if (flavor && flavor !== 'any' && FLAVORS[flavor].some((k) => fl.includes(k))) score += 4;
            if (occasion === 'sport' && hay.includes('sport')) score += 1.5;
            if (occasion === 'snus' && (hay.includes('snus') || hay.includes('switch'))) score += 1;
            score -= parseInt(el.dataset.idx, 10) * 0.01; // bei Gleichstand: Reihenfolge der Kollektion
            return { el, score };
          });
          scored.sort((a, b) => b.score - a.score);
          const list = this.querySelector('[data-results]');
          items.forEach((el) => (el.hidden = true));
          scored.slice(0, 3).reverse().forEach(({ el }) => {
            el.hidden = false;
            list.prepend(el);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piq-partner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href="#piq-partner-form"]');
    if (!a) return;
    const target = document.getElementById('piq-partner-form') || document.querySelector('form[action*="contact"]');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    const field = target.querySelector('input:not([type="hidden"]), textarea');
    if (field) setTimeout(() => field.focus({ preventScroll: true }), 500);
  });

  } catch(e) { console.error(e); }
})();
})();
